import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uitools"
    }}>{`UITools`}</h1>
    <p>{`The enumeration of tool box tools.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`No selection`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SELECTION_TOOL`}</strong>{` = 1936018548`}</p>
      <p parentName="blockquote">{`The selection tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DIRECT_SELECTION_TOOL`}</strong>{` = 1685277812`}</p>
      <p parentName="blockquote">{`The direct selection tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GAP_TOOL`}</strong>{` = 1734430836`}</p>
      <p parentName="blockquote">{`The gap tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PEN_TOOL`}</strong>{` = 1885687412`}</p>
      <p parentName="blockquote">{`The pen tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ADD_ANCHOR_POINT`}</strong>{` = 1633767540`}</p>
      <p parentName="blockquote">{`The add anchor point tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DELETE_ANCHOR_POINT`}</strong>{` = 1684099188`}</p>
      <p parentName="blockquote">{`The delete anchor point tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CONVERT_DIRECTION_POINT`}</strong>{` = 1667518580`}</p>
      <p parentName="blockquote">{`The convert direction point tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_TOOL`}</strong>{` = 1819169900`}</p>
      <p parentName="blockquote">{`The line tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TYPE_TOOL`}</strong>{` = 1954107508`}</p>
      <p parentName="blockquote">{`The type tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TYPE_ON_PATH_TOOL`}</strong>{` = 1953452148`}</p>
      <p parentName="blockquote">{`The type on a path tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PENCIL_TOOL`}</strong>{` = 1886274412`}</p>
      <p parentName="blockquote">{`The pencil tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SMOOTH_TOOL`}</strong>{` = 1936544872`}</p>
      <p parentName="blockquote">{`The smooth tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ERASE_TOOL`}</strong>{` = 1701991269`}</p>
      <p parentName="blockquote">{`The erase tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POLYGON_FRAME_TOOL`}</strong>{` = 1885754476`}</p>
      <p parentName="blockquote">{`The polygon frame tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RECTANGLE_FRAME_TOOL`}</strong>{` = 1919308908`}</p>
      <p parentName="blockquote">{`The rectangle frame tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ELLIPSE_FRAME_TOOL`}</strong>{` = 1701205100`}</p>
      <p parentName="blockquote">{`The ellipse frame tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POLYGON_TOOL`}</strong>{` = 1886147692`}</p>
      <p parentName="blockquote">{`The polygon tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RECTANGLE_TOOL`}</strong>{` = 1919243372`}</p>
      <p parentName="blockquote">{`The rectangle tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ELLIPSE_TOOL`}</strong>{` = 1701598316`}</p>
      <p parentName="blockquote">{`The ellipse tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ROTATE_TOOL`}</strong>{` = 1919898732`}</p>
      <p parentName="blockquote">{`The rotate tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SCALE_TOOL`}</strong>{` = 1935889516`}</p>
      <p parentName="blockquote">{`The scale tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SHEAR_TOOL`}</strong>{` = 1936217196`}</p>
      <p parentName="blockquote">{`The shear tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SCISSORS_TOOL`}</strong>{` = 1935891060`}</p>
      <p parentName="blockquote">{`The scissors tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FREE_TRANSFORM_TOOL`}</strong>{` = 1718899820`}</p>
      <p parentName="blockquote">{`The free transform tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GRADIENT_SWATCH_TOOL`}</strong>{` = 1735611500`}</p>
      <p parentName="blockquote">{`The gradient swatch tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GRADIENT_FEATHER_TOOL`}</strong>{` = 1734759532`}</p>
      <p parentName="blockquote">{`The gradient feather tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NOTE_TOOL`}</strong>{` = 1852789868`}</p>
      <p parentName="blockquote">{`The note tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EYE_DROPPER_TOOL`}</strong>{` = 1701074028`}</p>
      <p parentName="blockquote">{`The eye dropper tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MEASURE_TOOL`}</strong>{` = 1835357292`}</p>
      <p parentName="blockquote">{`The measure tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HAND_TOOL`}</strong>{` = 1751209068`}</p>
      <p parentName="blockquote">{`The hand tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ZOOM_TOOL`}</strong>{` = 2053985388`}</p>
      <p parentName="blockquote">{`The zoom tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TABLE_TOOL`}</strong>{` = 1952601196`}</p>
      <p parentName="blockquote">{`The table creation tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PLACE_CURSOR_TOOL`}</strong>{` = 1885557868`}</p>
      <p parentName="blockquote">{`The place cursor tool which gets set after an import via the Place command`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MOTION_PATH_TOOL`}</strong>{` = 1836078188`}</p>
      <p parentName="blockquote">{`The motion path tool`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_TOOL`}</strong>{` = 1936741484`}</p>
      <p parentName="blockquote">{`The page tool`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      